import BaseService from "../common/base.service";
import http from "../http-common";

class AuthService extends BaseService {
	constructor() {
		super('auth');
	}

	async check() {
		const result = await http.post(`/${this.classPlural}/_check`);
		return result;
	}

	async login(source, data) {
		const result = await http.post(`/${this.classPlural}/_login/${source}`, data);
		return result;
	}

	async logout() {
		const result = await http.post(`/${this.classPlural}/_logout`);
		return result;
	}
}

export default new AuthService();